(function ({ jQuery: $ }) {
  /*! ===== 여기에 스크립트를 작성해 주세요. ===== */

  /**
   * 내부 링크를 클릭했을 때 점프하는 대신 스무스하게 스크롤합니다.
   */
  $(document).on('click', 'a[href^="#"]', function (event) {
    const targetSelector = this.hash || '.body';
    const target = document.querySelector(targetSelector);

    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } else {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(target).offset().top,
      });
    }

    event.preventDefault();
  });

  /**
   * .js-toggle class를 가진 체크박스가 변경될 때, data-target으로 명시된
   * 타겟 엘리먼트에 data-class로 명시된 class를 토글합니다.
   *
      <input type="checkbox" class="js-toggle" data-target="#targetElement" data-class="active" />
      <div id="targetElement">This will be toggled with `active` class</div>
   */
  $(document).on('change', '.js-toggle', function () {
    var $toggler = $(this);
    var $target = $($toggler.data('target'));
    var className = $toggler.data('class');
    var isChecked = $toggler.is(':checked');

    if (!$target.length) {
      console.error(
        'Please specify the element to toggle with `data-toggle` attribute.'
      );
      return;
    }
    if (!className) {
      console.error(
        'Please specify the className to toggle with `data-class` attribute.'
      );
      return;
    }

    $target.toggleClass(className, isChecked);
  });

  /**
   * .js-tabs class를 가진 컨테이너 내에서 button 클릭이 일어나면,
   * 동일한 인덱스를 가진 탭 패널을 찾아 화면에 표시하고, 다른 패널을 감춥니다.
   */
  $(document).on('click', '.js-tabs .tab', function () {
    const $currentTab = $(this);
    const $container = $currentTab.closest('.js-tabs');
    const { $tabs } = getTabsRef($container);
    const currentIndex = $tabs.index($currentTab);

    goToTab(currentIndex, $container);
  });

  $('.js-tabs').each(function () {
    setupIndicator(this);
    goToTab(0, this);
  });

  function goToTab(index, container) {
    const { $indicator, $panels, $tabs } = getTabsRef(container);
    const $currentTab = $tabs.eq(index);
    const currentTabOffsetX = $currentTab.get(0).offsetLeft;
    const currentTabWidth = $currentTab.width();

    $tabs.removeClass('active').eq(index).addClass('active');
    $panels.attr('hidden', true).eq(index).removeAttr('hidden');
    $indicator.css({ left: currentTabOffsetX, width: currentTabWidth });
  }

  function getTabsRef(container) {
    const $container = $(container);
    const $tabs = $container.find('.tab');
    const $panels = $container.find('.tabpanel');
    const $indicator = $container.find('.tabs_indicator');

    return {
      $container,
      $indicator,
      $panels,
      $tabs,
    };
  }

  function setupIndicator(container) {
    const $indicator = $('<span />', {
      class: 'tabs_indicator',
    });
    const $holder = $(container).find('.tabs');

    $holder.append($indicator);
  }

  /* header */
  $('#menu').on('click', '.header_menu_link', function (event) {
    const $menuItem = $(this);
    const $submenu = $menuItem.next('.header_menu_subgroup');

    if ($submenu.length) {
      event.preventDefault();
      $menuItem.closest('.header_menu_item').toggleClass('active');
    }
  });
})(
  (function (jQuery) {
    requireModule('jQuery', typeof jQuery === 'function');

    function requireModule(name, predicate) {
      if (!predicate) {
        throw new Error(
          `Unable to find ${name} module. Please make sure it is loaded before this script.`
        );
      }
    }

    return { jQuery };
  })(window.jQuery)
);
